import axiosWrapper from "common/axiosWrapper";

export const getDiscordUrl = async () => {
	return await axiosWrapper.getCached(`api/auth/discord-url`);
};

export const getGoogleUrl = async () => {
	return await axiosWrapper.getCached(`api/auth/google-url`);
};

export const getRedditUrl = async () => {
	return await axiosWrapper.getCached(`api/auth/reddit-url`);
};
